module.exports = __webpack_public_path__ + "static/img/instore_row4_icon1.dfdbd8a8.png";